(function(){"use strict";(r=>{try{if(typeof window>"u")return;var e=document.createElement("style");e.appendChild(document.createTextNode(r)),document.head.appendChild(e)}catch(i){console.error("vite-plugin-css-injected-by-js",i)}})(".audio-recorder{background-color:#ebebeb;box-shadow:0 2px 5px #bebebe;border-radius:20px;box-sizing:border-box;color:#000;width:40px;display:flex;align-items:center;transition:all .2s ease-in;-webkit-tap-highlight-color:transparent}.audio-recorder-mic{box-sizing:content-box;cursor:pointer;height:16px;color:#000;padding:12px}.audio-recorder .audio-recorder-mic{border-radius:20px}.audio-recorder.recording .audio-recorder-mic{border-radius:0}.audio-recorder-timer,.audio-recorder-status{color:#000;margin-left:10px;font-family:Segoe UI,Tahoma,Geneva,Verdana,sans-serif;font-size:14px;font-weight:400;line-height:1}.audio-recorder-status{margin-left:15px;display:flex;align-items:baseline;flex-grow:1;animation-name:fading-ar-status;animation-duration:2s;animation-iteration-count:infinite}.audio-recorder-status-dot{background-color:#d00;border-radius:50%;height:10px;width:9px;margin-right:5px}.audio-recorder-options{box-sizing:content-box;height:16px;cursor:pointer;padding:12px 6px 12px 12px}.audio-recorder-options~.audio-recorder-options{padding:12px 12px 12px 6px;border-radius:0 5px 5px 0}.recording{border-radius:12px;width:300px;transition:all .2s ease-out}.display-none{display:none}.audio-recorder-visualizer{margin-left:15px;flex-grow:1;align-self:center;display:flex;align-items:center}@keyframes fading-ar-status{0%{opacity:1}50%{opacity:0}to{opacity:1}}")})();
import i, { useState as d, useCallback as r, useEffect as k, Suspense as P } from "react";
const H = (t, j) => {
  const [w, z] = d(!1), [y, N] = d(!1), [T, M] = d(0), [e, s] = d(), [c, D] = d(), [I, n] = d(), u = r(() => {
    const L = setInterval(() => {
      M((g) => g + 1);
    }, 1e3);
    D(L);
  }, [M, D]), a = r(() => {
    c != null && clearInterval(c), D(void 0);
  }, [c, D]), S = r(() => {
    c == null && navigator.mediaDevices.getUserMedia({ audio: t != null ? t : !0 }).then((L) => {
      z(!0);
      const g = new MediaRecorder(L);
      s(g), g.start(), u(), g.addEventListener("dataavailable", (m) => {
        n(m.data), g.stream.getTracks().forEach((C) => C.stop()), s(void 0);
      });
    }).catch((L) => {
      console.log(L.name, L.message, L.cause), j == null || j(L);
    });
  }, [
    c,
    z,
    s,
    u,
    n,
    j
  ]), A = r(() => {
    e == null || e.stop(), a(), M(0), z(!1), N(!1);
  }, [
    e,
    M,
    z,
    N,
    a
  ]), l = r(() => {
    y ? (N(!1), e == null || e.resume(), u()) : (N(!0), a(), e == null || e.pause());
  }, [e, N, u, a]);
  return {
    startRecording: S,
    stopRecording: A,
    togglePauseResume: l,
    recordingBlob: I,
    isRecording: w,
    isPaused: y,
    recordingTime: T,
    mediaRecorder: e
  };
}, O = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQ3MCA0NzAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ3MCA0NzA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCgk8Zz4NCgkJPHBhdGggZD0iTTIzNSwzMDIuMjk2YzQ3LjE3NywwLDg1LjQyMy0zOC4yNDUsODUuNDIzLTg1LjQyM1Y4NS40MjNDMzIwLjQyMywzOC4yNDUsMjgyLjE3NywwLDIzNSwwcy04NS40MjMsMzguMjQ1LTg1LjQyMyw4NS40MjMNCgkJCXYxMzEuNDUxQzE0OS41NzcsMjY0LjA1MSwxODcuODIzLDMwMi4yOTYsMjM1LDMwMi4yOTZ6Ii8+DQoJCTxwYXRoIGQ9Ik0zNTAuNDIzLDEzNi4xNDh2MzBoMTV2NTAuNzI2YzAsNzEuOTE1LTU4LjUwOCwxMzAuNDIzLTEzMC40MjMsMTMwLjQyM3MtMTMwLjQyMy01OC41MDctMTMwLjQyMy0xMzAuNDIzdi01MC43MjZoMTV2LTMwDQoJCQloLTQ1djgwLjcyNkM3NC41NzcsMzAwLjI3MywxMzguNTUxLDM2OSwyMjAsMzc2LjU4OVY0NDBoLTkwLjQ0NHYzMGgyMTAuODg5di0zMEgyNTB2LTYzLjQxMQ0KCQkJYzgxLjQ0OS03LjU4OSwxNDUuNDIzLTc2LjMxNywxNDUuNDIzLTE1OS43MTZ2LTgwLjcyNkgzNTAuNDIzeiIvPg0KCTwvZz4NCjwvc3ZnPg0K", v = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDcuNjA3IDQ3LjYwNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDcuNjA3IDQ3LjYwNzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KCTxnPg0KCQk8cGF0aCBkPSJNMTcuOTkxLDQwLjk3NmMwLDMuNjYyLTIuOTY5LDYuNjMxLTYuNjMxLDYuNjMxbDAsMGMtMy42NjIsMC02LjYzMS0yLjk2OS02LjYzMS02LjYzMVY2LjYzMUM0LjcyOSwyLjk2OSw3LjY5OCwwLDExLjM2LDANCgkJCWwwLDBjMy42NjIsMCw2LjYzMSwyLjk2OSw2LjYzMSw2LjYzMVY0MC45NzZ6Ii8+DQoJCTxwYXRoIGQ9Ik00Mi44NzcsNDAuOTc2YzAsMy42NjItMi45NjksNi42MzEtNi42MzEsNi42MzFsMCwwYy0zLjY2MiwwLTYuNjMxLTIuOTY5LTYuNjMxLTYuNjMxVjYuNjMxDQoJCQlDMjkuNjE2LDIuOTY5LDMyLjU4NSwwLDM2LjI0NiwwbDAsMGMzLjY2MiwwLDYuNjMxLDIuOTY5LDYuNjMxLDYuNjMxVjQwLjk3NnoiLz4NCgk8L2c+DQo8L3N2Zz4NCg==", G = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQ5NC4xNDggNDk0LjE0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDk0LjE0OCA0OTQuMTQ4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQoJPGc+DQoJCTxnPg0KCQkJPHBhdGggZD0iTTQwNS4yODQsMjAxLjE4OEwxMzAuODA0LDEzLjI4QzExOC4xMjgsNC41OTYsMTA1LjM1NiwwLDk0Ljc0LDBDNzQuMjE2LDAsNjEuNTIsMTYuNDcyLDYxLjUyLDQ0LjA0NHY0MDYuMTI0DQoJCQkJYzAsMjcuNTQsMTIuNjgsNDMuOTgsMzMuMTU2LDQzLjk4YzEwLjYzMiwwLDIzLjItNC42LDM1LjkwNC0xMy4zMDhsMjc0LjYwOC0xODcuOTA0YzE3LjY2LTEyLjEwNCwyNy40NC0yOC4zOTIsMjcuNDQtNDUuODg0DQoJCQkJQzQzMi42MzIsMjI5LjU3Miw0MjIuOTY0LDIxMy4yODgsNDA1LjI4NCwyMDEuMTg4eiIvPg0KCQk8L2c+DQoJPC9nPg0KPC9zdmc+DQo=", J = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik0xNy44NSAzLjE1bC0yLjk5LTNBLjUwOC41MDggMCAwIDAgMTQuNSAwSDEuNEExLjQxNyAxLjQxNyAwIDAgMCAwIDEuNDN2MTUuMTRBMS40MTcgMS40MTcgMCAwIDAgMS40IDE4aDE1LjJhMS40MTcgMS40MTcgMCAwIDAgMS40LTEuNDNWMy41YS40Ny40NyAwIDAgMC0uMTUtLjM1ek0yIDVWM2ExIDEgMCAwIDEgMS0xaDhhMSAxIDAgMCAxIDEgMXYyYTEgMSAwIDAgMS0xIDFIM2ExIDEgMCAwIDEtMS0xem03IDExYTQgNCAwIDEgMSA0LTQgNCA0IDAgMCAxLTQgNHoiLz4NCjwvc3ZnPg0K", B = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDYuNzM0IDQ2LjczNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDYuNzM0IDQ2LjczNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZD0iTTQxLjM0NiwwSDUuMzg4QzIuNDE3LDAsMCwyLjQxNywwLDUuMzg4djM1Ljk1OGMwLDIuOTcxLDIuNDE3LDUuMzg4LDUuMzg4LDUuMzg4aDM1Ljk1OGMyLjk3MSwwLDUuMzg4LTIuNDE3LDUuMzg4LTUuMzg4DQoJCVY1LjM4OEM0Ni43MzMsMi40MTcsNDQuMzE2LDAsNDEuMzQ2LDB6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==";
const U = i.lazy(async () => {
  const { LiveAudioVisualizer: t } = await import("./react-audio-visualize.es.0ccda538.mjs");
  return { default: t };
}), p = ({
  onRecordingComplete: t,
  onNotAllowedOrFound: j,
  recorderControls: w,
  audioTrackConstraints: z,
  downloadOnSavePress: y = !1,
  downloadFileExtension: N = "mp3",
  showVisualizer: T = !1,
  classes: M
}) => {
  var g, m, C, Q, b, Y;
  const {
    startRecording: e,
    stopRecording: s,
    togglePauseResume: c,
    recordingBlob: D,
    isRecording: I,
    isPaused: n,
    recordingTime: u,
    mediaRecorder: a
  } = w != null ? w : H(z, j), [S, A] = d(!1), l = (E = !0) => {
    A(E), s();
  }, L = (E) => {
    const x = new Blob([E], {
      type: `audio/${N}`
    }), Z = URL.createObjectURL(x), o = document.createElement("a");
    o.style.display = "none", o.href = Z, o.download = `audio.${N}`, document.body.appendChild(o), o.click(), o.remove();
  };
  return k(() => {
    (S || w) && D != null && t != null && (t(D), y && L(D));
  }, [D]), /* @__PURE__ */ i.createElement(
    "div",
    {
      className: `audio-recorder ${I ? "recording" : ""} ${(g = M == null ? void 0 : M.AudioRecorderClass) != null ? g : ""}`,
      "data-testid": "audio_recorder"
    },
    /* @__PURE__ */ i.createElement(
      "img",
      {
        src: I ? J : O,
        className: `audio-recorder-mic ${(m = M == null ? void 0 : M.AudioRecorderStartSaveClass) != null ? m : ""}`,
        onClick: I ? () => l() : e,
        "data-testid": "ar_mic",
        title: I ? "Save recording" : "Start recording"
      }
    ),
    /* @__PURE__ */ i.createElement(
      "span",
      {
        className: `audio-recorder-timer ${I ? "" : "display-none"} ${(C = M == null ? void 0 : M.AudioRecorderTimerClass) != null ? C : ""}`,
        "data-testid": "ar_timer"
      },
      Math.floor(u / 60),
      ":",
      String(u % 60).padStart(2, "0")
    ),
    T ? /* @__PURE__ */ i.createElement(
      "span",
      {
        className: `audio-recorder-visualizer ${I ? "" : "display-none"}`
      },
      a && /* @__PURE__ */ i.createElement(P, { fallback: /* @__PURE__ */ i.createElement(i.Fragment, null) }, /* @__PURE__ */ i.createElement(
        U,
        {
          mediaRecorder: a,
          barWidth: 2,
          gap: 2,
          width: 140,
          height: 30,
          fftSize: 512,
          maxDecibels: -10,
          minDecibels: -80,
          smoothingTimeConstant: 0.4
        }
      ))
    ) : /* @__PURE__ */ i.createElement(
      "span",
      {
        className: `audio-recorder-status ${I ? "" : "display-none"} ${(Q = M == null ? void 0 : M.AudioRecorderStatusClass) != null ? Q : ""}`
      },
      /* @__PURE__ */ i.createElement("span", { className: "audio-recorder-status-dot" }),
      "Recording"
    ),
    /* @__PURE__ */ i.createElement(
      "img",
      {
        src: n ? G : v,
        className: `audio-recorder-options ${I ? "" : "display-none"} ${(b = M == null ? void 0 : M.AudioRecorderPauseResumeClass) != null ? b : ""}`,
        onClick: c,
        title: n ? "Resume recording" : "Pause recording",
        "data-testid": "ar_pause"
      }
    ),
    /* @__PURE__ */ i.createElement(
      "img",
      {
        src: B,
        className: `audio-recorder-options ${I ? "" : "display-none"} ${(Y = M == null ? void 0 : M.AudioRecorderDiscardClass) != null ? Y : ""}`,
        onClick: () => l(!1),
        title: "Discard Recording",
        "data-testid": "ar_cancel"
      }
    )
  );
};
export {
  p as AudioRecorder,
  H as useAudioRecorder
};
